import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RightAngledTriangleMirroredDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'right-angled-triangle-mirrored', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const base = computed({
	get: () => dimensions.value.base,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "base",
			value: value,
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "right-angled-triangle-mirrored-base",
        id: `${_ctx.prefix}measurements-right-angled-triangle-mirrored-base`,
        name: `${_ctx.prefix}measurements[dimensions][base]`,
        unit: "cm",
        label: dimensionLabel.value('width', 'right-angled-triangle-mirrored'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}right-angled-triangle-mirrored-base`),
        onBlur: () => _unref(addSizeToDataLayer)('base', +base.value, 'right-angled-triangle-mirrored'),
        modelValue: base.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((base).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "right-angled-triangle-mirrored-height",
        id: `${_ctx.prefix}measurements-right-angled-triangle-mirrored-height`,
        name: `${_ctx.prefix}measurements[dimensions][height]`,
        unit: "cm",
        label: dimensionLabel.value('height', 'right-angled-triangle-mirrored'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}right-angled-triangle-mirrored-height`),
        onBlur: () => _unref(addSizeToDataLayer)('height', +height.value, 'right-angled-triangle-mirrored'),
        modelValue: height.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((height).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})